import tree from "../../../components/tree.vue"
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import { emailRule, domainName } from '@/utility/index.js'

export default {
    name: "JurisdictionalCompanies",
    components: { tree, iTable, IPagination },
    data() {
        return {
            dialogVisible: false,
            height: '550',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            columns: [
                {
                    prop: "regulationsTitle",
                    label: this.$t('GovernmentRegulation.noteTitle'),
                    align: "center",
                    width: "200px"
                },
                {
                    prop: "regulationsContent",
                    label: this.$t('GovernmentRegulation.regulationsContent'),
                    align: "center",
                },
                {
                    prop: "issueTime",
                    label: this.$t('GovernmentRegulation.issueTime'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "isFilePath",
                    label: this.$t('GovernmentRegulation.isFilePath'),
                    align: "center",
                    width: "140px",
                    render: (h, params) => {
                        if (params.row.isFilePath == 1) {
                            return h('el-button',
                                {
                                    props: {
                                        type: 'text', size: 'small', icon: 'iconfont iconxiazai-copy'
                                    },
                                    on: {
                                        click: () => {
                                            this.downFile(params.row)
                                        }
                                    }
                                }, '')
                        } else {
                            return h('el-button',
                                {
                                    props: {
                                        type: 'text', size: 'small', icon: 'iconfont iconxiazai', disabled: true
                                    },
                                }, '')
                        }
                    }
                },
            ],
            operates: {
                width: 60,
                fixed: "right",
                list: [],
            },
            currentPage: 1, 
            pageSize: 10,
            total: 1, 

            dialogFormVisible: false,
            formLabelWidth: '80px',
            diaTitle: '',
            btnType: '',
            form: {
                regulationsTitle: '',
                regulationsContent: '',
                filePath: ''
            },
            selected: [],
        };
    },
    created() {
        
    },
    mounted() {
        this.getPolicyRule()
    },
    methods: {
        getPolicyRule() {
            let param = {
                jurisdictionNum: sessionStorage.getItem('jurisdictionNum'),
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }
            this.$store.dispatch('PolicyRule/GET_GETREGULATIONS', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            })
        },

        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getPolicyRule();
        },

        addPolicyRule() {
            this.dialogFormVisible = true;
            this.diaTitle = this.$t('common.btn.add')
            this.btnType = 'add'
            this.form.filePath = ''
            this.$nextTick(() => {
                this.$refs.form.resetFields()
                document.getElementById('uploadFile').value = ''
            })

        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        jurisdictionNum: sessionStorage.getItem('jurisdictionNum'),
                        regulationsTitle: this.form.regulationsTitle,
                        regulationsContent: this.form.regulationsContent,
                        filePath: this.form.filePath
                    }
                    if (this.btnType == 'add') {
                        this.$store.dispatch('PolicyRule/GET_INSERTREGULATIONS', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.addSuccess'))
                                this.dialogFormVisible = false;
                                this.getPolicyRule();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    }
                } else {
                    return false;
                }
            });
        },
        uploadFiles() {
            let dom = document.getElementById('uploadFile')
            let file = dom.files[0];
            console.log(file)
            let formData = new FormData()
            formData.append('file', file)
            this.$store.dispatch('FileController/GET_UPLOADCONTRACTFILE', formData).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(this.$t('common.btn.fileUploadSuccess'))
                    this.form.filePath = res.data.data[0]
                } else {
                    this.$message.error(res.data.msg)
                }
            }).catch(err => {
                this.$message.error(this.$t('common.btn.fileUploadError'))
                document.getElementById('uploadFile').value = ''
            })
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                regulationsTitle: '',
                regulationsContent: '',
                filePath: ''
            }
        },
        closeDia() {
            this.form = {
                regulationsTitle: '',
                regulationsContent: '',
                filePath: ''
            }
            this.dialogFormVisible = false;
        },

        deletePolicyRule() {
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = { oddNum: this.selected[0].oddNum }
                    this.$store.dispatch('PolicyRule/GET_DELETEREGULATIONS', param).then(response => {
                        if (response.data.code == 200) {
                            this.getPolicyRule()
                            this.$message.success(this.$t('common.btn.deleteSuccess'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },

        downFile(row) {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/FileController/getFile?filePath=${row.filePath}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/FileController/getFile?filePath=${row.filePath}`
                    location.href = url
                }
            }
        },
    },
};
